"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderHandle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../DragSlider/context");
const DEFAULT_BG = '#d4d4d4';
const DEFAULT_SHADOW = '0 0 2px rgba(0,0,0,0.4), inset 0 0 1px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6), 0 4px 2px rgba(0,0,0,0.2), 0 9px 4px rgba(0,0,0,0.1), inset 0 2px 1px rgba(255,255,255,1.0)';
/**
 * Outer container reserves a fixed 16x16 layout footprint so the inner thumb
 * can morph.
 */
const containerClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'inline-block',
    w: '16px',
    h: '16px',
    va: 'middle',
    bxz: 'border-box',
});
const thumbClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    w: '16px',
    h: '16px',
    bdrad: '20px',
    bd: 0,
    pad: 0,
    out: 'none',
    trs: 'background-color .1s, box-shadow .1s, width .1s, height .1s, outline .1s',
    '&:hover': {
        out: '6px solid rgba(127,127,127,.12)',
    },
    '&:before': {
        content: '""',
        pos: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        w: '14px',
        h: '14px',
        bdrad: '50%',
        bg: 'radial-gradient(rgba(255,255,255,0.85), rgba(255,255,255,0.1) 55%, rgba(255,255,255,0.0) 75%)',
        pe: 'none',
    },
    '&:after': {
        content: '""',
        pos: 'absolute',
        top: '-5px',
        left: '2px',
        w: '15px',
        h: '15px',
        bdrad: '12px',
        bg: 'radial-gradient(rgba(255,255,255,1.0), rgba(255,255,255,0.05), rgba(255,255,255,0.0))',
        pe: 'none',
        trs: 'top .1s, left .1s',
    },
});
const thumbDraggingClass = (0, nano_theme_1.rule)({
    w: '8px',
    h: '24px',
    out: '6px solid rgba(127,127,127,.12)',
    '&:after': {
        top: '-5px',
        left: '-1px',
    },
});
const thumbDraggingHorizontalClass = (0, nano_theme_1.rule)({
    w: '24px',
    h: '8px',
    out: '6px solid rgba(127,127,127,.12)',
    '&:after': {
        top: '0px',
        left: '14px',
        w: '8px',
        h: '4px',
    },
});
const disabledClass = (0, nano_theme_1.rule)({
    op: 0.5,
});
const SliderHandle = ({ dragging, axis, disabled, background, boxShadow, className, style, }) => {
    const dragSliderState = (0, context_1.useDragSliderState)();
    const effectiveDragging = dragging ?? dragSliderState?.dragging ?? false;
    const effectiveAxis = axis ?? dragSliderState?.axis ?? 'x';
    const bg = background ?? DEFAULT_BG;
    const shadow = boxShadow ?? DEFAULT_SHADOW;
    const outerClass = containerClass + (disabled ? ' ' + disabledClass : '') + (className ? ' ' + className : '');
    const draggingThumb = effectiveAxis === 'y' ? thumbDraggingHorizontalClass : thumbDraggingClass;
    const inner = thumbClass + (effectiveDragging ? ' ' + draggingThumb : '');
    return (React.createElement("span", { className: outerClass, style: style },
        React.createElement("span", { className: inner, style: { background: bg, boxShadow: shadow } })));
};
exports.SliderHandle = SliderHandle;
